import React from 'react';
import { RenderAditionalInfo } from '../AditionalInfo';
import { Align, FontSize } from '../../../modules/ReceiptLayouts/Model';
import { isBoolean } from 'util';
export var BlockAditionalInfo = function (_a) {
    var aditionalInfo = _a.aditionalInfo, align = _a.align, fontSize = _a.fontSize, bold = _a.bold;
    return (React.createElement(RenderAditionalInfo, { aditionalInfo: aditionalInfo, align: align || defaultProps.align, fontSize: fontSize || defaultProps.fontSize, bold: isBoolean(bold) ? bold : defaultProps.bold }));
};
var defaultProps = {
    align: Align.Center,
    fontSize: FontSize.small,
    bold: false
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockAditionalInfo.tsx
// module id = 486
// module chunks = 0